/* wle:auto-imports:start */
import {EnemyComponent} from './js/components/enemy-component.js';
/* wle:auto-imports:end */

export default function (engine) {
    /* wle:auto-register:start */
engine.registerComponent(EnemyComponent);
/* wle:auto-register:end */
}
